import { render } from "./icon-pe7.vue?vue&type=template&id=500efef2"
import script from "./icon-pe7.vue?vue&type=script&lang=js"
export * from "./icon-pe7.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__